import Cookies from "js-cookie";
import { parseOfficeCodes } from "./claimsOfficeUtils";

export const getClaimsAccess = () => {
  let orgTypes = [];
  try {
    orgTypes = JSON.parse(localStorage.getItem("organizationTypes") || "[]");
  } catch {
    orgTypes = [];
  }

  const normalized = (Array.isArray(orgTypes) ? orgTypes : [])
    .map((t) => String(t ?? "").toLowerCase().trim())
    .filter(Boolean);

  const isPureCarrier = normalized.length === 1 && normalized[0] === "carrier";
  const isShipper = normalized.includes("shipper");

  let isAdmin = false;
  try {
    const privileges = JSON.parse(localStorage.getItem("userPrivileges") || "[]");
    isAdmin = privileges.some((p) => p.name === "shipments:ADMIN_VIEW");
  } catch {
    isAdmin = false;
  }

  /** Shipper org + shipments:ADMIN_VIEW; carrier-only orgs excluded. */
  const isShipperAdmin = isShipper && isAdmin && !isPureCarrier;

  const officeCodes = parseOfficeCodes(Cookies.get("officeCodes"));
  const officeCode = officeCodes[0] || Cookies.get("officeCodes") || "";

  return {
    isCarrier: isPureCarrier,
    isShipper,
    isShipperAdmin,
    canCreateClaim: isShipperAdmin,
    /**
     * LGX-1044: only a Shipper Admin may change a claim. Carriers are the party being
     * claimed against, so they get the same screens read-only - the backend rejects a
     * carrier hitting the update endpoints regardless of what the UI renders.
     */
    canEditClaim: isShipperAdmin,
    officeCode,
    officeCodes,
  };
};
